/* The one truly generic piece of archetype B's record header: a row of at-a-glance figures under
   the title, before the detail cards — `docs/design/order-page.html` / `return-page.html`'s own
   `.kpis`. Shared so returns and orders (and any future archetype-B record header) don't grow two
   slightly different copies of the same four divs. Styles are `.dp-kpi*` in `detail-page.scss`. */

import React from "react";

export function KpiStrip({ items }) {
  const visible = (items || []).filter(Boolean);
  if (!visible.length) return null;

  return (
    <div className="dp-kpis">
      {visible.map(({ key, label, value }) => (
        <div className="dp-kpi" key={key}>
          <div className="dp-kpi__label">{label}</div>
          <div className="dp-kpi__value">{value}</div>
        </div>
      ))}
    </div>
  );
}
